import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../../utils/supabaseClient';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [noProfile, setNoProfile] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setNoProfile(false);

    const cleanedEmail = email.trim().toLowerCase();

    // 1) Sign in
    const { data: loginData, error: loginError } = await supabase.auth.signInWithPassword({
      email: cleanedEmail,
      password,
    });

    if (loginError) {
      setErrorMsg(
        loginError.message === 'Invalid login credentials'
          ? 'Incorrect email/password or your email is not yet confirmed.'
          : loginError.message
      );
      return;
    }

    const user = loginData.user;
    if (!user) {
      setErrorMsg('Login failed. Please try again.');
      return;
    }

    // 2) Check for accounts (RLS safe)
    const { data: profile, error: profileError } = await supabase
      .from('accounts')
      .select('id')
      .eq('id', user.id)
      .maybeSingle();

    if (profileError) {
      console.error('Failed to fetch profile:', profileError);
    }

    if (!profile) {
      setNoProfile(true);
      return;
    }

    // 3) Navigate to main page
    navigate('/create');
  };

  return (
    <section className="auth-page contain contain-smaller align-middle">
      <h1>Welcome back</h1>

      {errorMsg && <p className="error-message">{errorMsg}</p>}
      {noProfile && (
        <p className="error-message">
          No profile found. <Link to="/signup" className="link-text">Sign up</Link>
        </p>
      )}

      <form onSubmit={handleLogin}>
        <label htmlFor="email">Email Address:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <div className="user-password">
          <label htmlFor="password">Password:</label>

          <div className="password-input-wrapper" style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="toggle-view-pw"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
            </span>
          </div>

          <Link to="/forgot-password" className="link-text">Forgot Password?</Link>
        </div>

        <div className="text-center">
          <button type="submit" className="btn mt-0">Continue</button>
        </div>
      </form>

      <div>
        <p>
          Don’t have an account?{' '}
          <Link to="/signup" className="link-text">Sign up</Link>
        </p>
      </div>

      <div className="legal-links">
        <p className="text-center">
          By continuing, you agree to the <br />
          <a href="/legal.html#terms-of-use" className="primary-text">Terms of Use</a> &{' '}
          <a href="/legal.html#privacy-policy" className="primary-text">Privacy Policy</a>
        </p>
      </div>
    </section>
  );
}

export default Login;